//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('vue-video-player/src/custom-theme.css')
require('video.js/dist/video-js.css')
import $ from "jquery";
let img = require("../assets/images/posturebodyview/testxo.jpg");
//console.log("img:",img)

import { videoPlayer } from 'vue-video-player'
import { setTimeout } from 'timers';
export default {
    components:{
        videoPlayer
    },
    name: 'Risk_ItemVideo',
    props:['videoUrl','pauseVideo','cover'],
    data () {
        return {
            video:'',
            playerOptions: {
                autoplay: false,
                preload: 'auto',
                teachOrder:['flash','html5'],
                muted: false,
                language: 'en',
                aspectRatio: '4:3',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    // mp4
                    src: this.videoUrl,
                    // webm
                    // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                }],
                //poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
                poster: this.cover

            }
        }
    },
    watch:{
        pauseVideo:function(){
            if(this.pauseVideo){
                //console.log("this.pausevie item:L",this.pauseVideo)
                this.$refs.videoPlayerRisk.player.pause()

            }
        }
    },
    computed: {
      player() {
        return this.$refs.videoPlayerRisk.player
      }
    },
    methods: {
         // listen event
        onPlayerPlay(player) {
            //console.log('player play!', player,player.paused())


            this.$emit('changeIsPause')
        },
        onPlayerPause(player) {
            //console.log('player pause!', player)
        },
        onPlayerEnded(player) {
            // //console.log('player ended!', player)
        },
        onPlayerLoadeddata(player) {
            // //console.log('player Loadeddata!', player)
        },
        onPlayerWaiting(player) {
            // //console.log('player Waiting!', player)
        },
        onPlayerPlaying(player) {
            // //console.log('player Playing!', player)
        },
        onPlayerTimeupdate(player) {
            // //console.log('player Timeupdate!', player.currentTime())
        },
        onPlayerCanplay(player) {
            // //console.log('player Canplay!', player)
        },
        onPlayerCanplaythrough(player) {
            // //console.log('player Canplaythrough!', player)
        },
        // or listen state event
        playerStateChanged(playerCurrentState) {
            // //console.log('player current update state', playerCurrentState)
        },
        // player is ready
        playerReadied(player) {
            // seek to 10s
            //console.log('example player 1 readied', player)
            player.currentTime(10)
            // //console.log('example 01: the player is readied', player)
        }
    },
    created:function(){

    },
    mounted(){
        var video = $("video")[0];
        var _this = this;
        $(".vjs-big-play-button").css("cssText", "height:2rem !important;line-height:2rem !important;width:3rem;left:54%;top:55%;")
        $(".vjs-poster").css("background-size",'100% 84%')
        $(".video-js").css("background","#fff")
        $(".vjs-poster").css("background-color","#fff")
        //$(".vjs-control-bar").css("opacity","1")
        //$(".vjs-poster").css("height",'88%')
        //$(".vjs-control-bar").css("opacity","1")
      /*   $(".vjs-poster").css("top","28px")
         $(".vjs-poster").css("height",'88%')
        $(".vjs-poster").css("right","-1px")
        $(".video-js").css("background","#fff")
        $(".video-js").css("top","-14px")
        $(".vjs-tech").css("top","-5px")
        $(".vjs-control-bar").css("opacity","1")
        $(".vjs-control-bar").css("bottom","0") */

        $('.vjs-paused,.vjs-playing').on('touchend',function(){
            var video = $("video")[0];
            var isPlay = video.paused;

            setTimeout(() => {
                if(isPlay){
                    video.pause();
                }else{
                    video.play();
                }
                //console.log("isplay:",isPlay)
            }, 400);

        })
        $(".vjs-fullscreen-control").on("touchend",function(event){

            setTimeout(function(){
               // $('.vjs-paused,.vjs-playing').trigger("touchend")
               //_this.$refs.videoPlayerRisk.player.isFu
              // $(".vjs-fullscreen-control").trigger("touchend")

           },200);
        })
        setTimeout(() => {
            //console.log('dynamic change options', this.player)
            this.player.muted(false)
        }, 5000)
    }
}



// WEBPACK FOOTER //
// ./src/components/Risk_ItemVideo.vue